import { PartyRounds, usePartyRounds } from "./usePartyRounds";

export interface PlayerRounds extends PartyRounds {

}

export const usePlayerRounds = (apiPath: string): PlayerRounds => usePartyRounds(apiPath, 'player');